import { RenderSelectInput } from "app/common/renderInput";
import { addUpdateAirlines } from "app/services/vendorService";
import { Field, Form as FormikForm, Formik } from "formik";
import { useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import * as Yup from "yup";
import UserGroupSearch from "./AutoComplete/UserGroupSearch";
import VendorAndCarrierSearch from "./AutoComplete/VendorAndCarrierSearch";

export default function SupplierAirlinesAddUpdate({
  initialValues,
  setInitialValues,
  show,
  handleClose,
  loadAirlines,
  edit,
  setEdit,
}) {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [userGroup, setUserGroup] = useState(null);
  const [selectedCarriers, setSelectedCarriers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Validation Schema
  const validationSchema = Yup.object({
    applyToAllUserGroups: Yup.boolean(),
    userGroupId: Yup.number().when("applyToAllUserGroups", {
      is: false, // When applyToAllUserGroups is false...
      then: Yup.number()
        .min(1, "User group is required")
        .required("User group is required"),
      otherwise: Yup.number().optional(),
    }),
    supplierId: Yup.number().min(1, "Supplier is required"),
    carrierIdList: Yup.array().min(1, "At least one airline must be selected"),
  });
  const closeHandler = () => {
    handleClose();
    setEdit(false);
    loadAirlines();
    setInitialValues({
      mode: "ADD",
      supplierId: 0,
      carrierIdList: [],
      status: true,
      userGroupId: 0,
      applyToAllUserGroups: false,
      domesticReturn: false,
      internationalReturn: false,
      domesticOneway: false,
      internationalOneway: false,
    });
    setSelectedVendor(null);
    setSelectedCarriers([]);
    setUserGroup(null);
  };
  // Submit Handler
  const handleSubmit = async (values, { resetForm }) => {
    const request = {
      mode: edit == false ? "ADD" : "EDIT",
      supplierId: values.supplierId,
      carrierIdList: values.carrierIdList,
      status: edit == false ? values.status : !values.status,
      userGroupId: values.userGroupId,
      applyToAllUserGroups: values.applyToAllUserGroups,
      enableDomesticReturn: values?.domesticReturn,
      enableInternationalReturn: values?.internationalReturn,
      enableDomesticOneway: values?.domesticOneway,
      enableInternationalOneway: values?.internationalOneway,
    };

    if (values.applyToAllUserGroups) {
      delete request.userGroupId;
    }

    setIsLoading(true);
    try {
      const response = await addUpdateAirlines(request);
      if (response.status === "Success") {
        NotificationManager.success(response.message);
      } else {
        NotificationManager.error(response.message);
      }
    } catch (error) {
      NotificationManager.error("Error while saving data");
    }
    setIsLoading(false);
    setSelectedVendor(null);
    setSelectedCarriers([]);
    resetForm(); // Reset form after successful submission
    closeHandler();
  };
  const StatusList = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>
          {edit == false ? "Add" : "Update"} Supplier Airlines
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            setFieldValue,
            touched,
            errors,
            handleChange,
            handleBlur,
          }) => (
            <FormikForm>
              <Row>
                <Col>
                  <RenderSelectInput
                    // type="number"
                    name="applyToAllUserGroups"
                    display={
                      <div
                        style={{
                          color: values.applyToAllUserGroups ? "green" : "red",
                        }}
                      >
                        Apply To All User Group
                      </div>
                    }
                    value={values.applyToAllUserGroups}
                    error={errors.applyToAllUserGroups}
                    onChange={(e) => {
                      debugger;
                      const selectedVal = e.target.value;
                      // If the value is a string, convert it
                      const booleanVal =
                        selectedVal == "true" || selectedVal == true;
                      setFieldValue("applyToAllUserGroups", booleanVal);
                    }}
                    onBlur={handleBlur}
                    touched={touched.applyToAllUserGroups}
                    items={StatusList}
                  ></RenderSelectInput>
                </Col>
              </Row>
              {!values.applyToAllUserGroups && (
                <Row className="mb-3">
                  <label>User Group</label>

                  <Col>
                    <UserGroupSearch
                      setSelected={setUserGroup}
                      selected={userGroup}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      name={"userGroupId"}
                      value={values.userGroupId}
                    />
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <label>Supplier Name</label>
                <Col>
                  <VendorAndCarrierSearch
                    type="vendor"
                    setSelected={setSelectedVendor}
                    selected={selectedVendor}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    edit={edit}
                    userGroupId={values.userGroupId}
                    value={values.supplierId}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <label>Airlines Name</label>
                <Col>
                  <VendorAndCarrierSearch
                    type="flight"
                    setSelected={setSelectedCarriers}
                    selected={selectedCarriers}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    edit={edit}
                    userGroupId={values.userGroupId}
                    value={values.carrierIdList}
                  />
                </Col>
              </Row>
              {edit && (
                <Row>
                  <Col>
                    <div className="form-check mb-3">
                      <Field
                        type="checkbox"
                        id="status"
                        name="status"
                        className={`form-check-input ${
                          values.status
                            ? "border-danger bg-danger"
                            : "border-primary"
                        }`}
                        checked={values.status} // Invert the value
                        onChange={() => setFieldValue("status", !values.status)} // Toggle status
                        style={{
                          borderColor: "red", // Set border color to red
                          accentColor: values.status ? "red" : "", // Change check color to red when checked
                        }}
                      />
                      <label
                        htmlFor="status"
                        className={`form-check-label fw-bold ${
                          values.status ? "text-danger" : "text-primary"
                        }`}
                      >
                        {values.status ? "Exclude" : "Include"}
                      </label>
                    </div>
                  </Col>
                </Row>
              )}
              <>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          JOURNEY TYPE
                        </div>
                      </th>
                      <th>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          ONEWAY
                        </div>
                      </th>
                      <th>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          RETURN
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          DOMESTIC
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="domesticOneway"
                            checked={values.domesticOneway}
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="domesticReturn"
                            checked={values.domesticReturn}
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          INTERNATIONAL
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="internationalOneway"
                            checked={values.internationalOneway}
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="internationalReturn"
                            checked={values.internationalReturn}
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </>
              <div className="d-flex justify-content-center">
                <Button
                  variant="secondary"
                  onClick={closeHandler}
                  className="me-2"
                >
                  Close
                </Button>
                {isLoading ? (
                  <Button variant="primary" disabled>
                    Please wait...
                  </Button>
                ) : (
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                )}
              </div>
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
